/* Keep the US2 drawer responsive while Focal's delayed focus activation is pending. */
(() => {
  const initialized = new WeakSet();

  document.addEventListener('mobile-nav:open', (event) => {
    const drawer = event.target;
    if (drawer.id !== 'mobile-menu-drawer' || !drawer.classList.contains('mm28')) return;

    const trap = drawer.focusTrap;
    if (!trap) return;

    if (!initialized.has(drawer)) {
      const activate = trap.activate.bind(trap);
      // Focal also activates after 150ms. A close during that interval must not
      // reactivate a hidden drawer's trap. This guard affects this instance only.
      trap.activate = (...args) => {
        if (!drawer.isConnected || !drawer.open) return trap;
        const result = activate(...args);
        // Also runs on Focal's delayed call: the click's default focus and the
        // opening visibility transition must not leave focus on the trigger.
        requestAnimationFrame(() => {
          if (drawer.open && !drawer.contains(document.activeElement)) {
            drawer.focus({ preventScroll: true });
          }
        });
        return result;
      };
      initialized.add(drawer);
    }

    // Activate now so Escape works from the first frame of the opening motion.
    trap.activate();
  });
})();
